var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dark-mode",
      class: { "overflow-x-hidden": this.resultPage.isMobile },
      attrs: { id: "app" },
    },
    [
      _c("delete-job-modal"),
      _vm._v(" "),
      _c("share-modal"),
      _vm._v(" "),
      _c("unlock-pro-modal"),
      _vm._v(" "),
      _c("credit-limit-modal"),
      _vm._v(" "),
      _c("unlock-pro-modal"),
      _vm._v(" "),
      _c("max-concurrent-limit-modal"),
      _vm._v(" "),
      _c("generic-error-modal"),
      _vm._v(" "),
      _c("job-failed-modal"),
      _vm._v(" "),
      _vm.resultPage.isMobile === false && _vm.resultPage.isFullRes === true
        ? _c("BaseLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "topbar",
                  fn: function () {
                    return [_c("router-view", { attrs: { name: "Topbar" } })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left-stacked",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "SidebarLeftStacked" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarLeft" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas-ad",
                  fn: function () {
                    return [
                      true === false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center banner-ad-size",
                            },
                            [_c("div", { attrs: { id: _vm.adId } })]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary-nav",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SecondaryNav" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas",
                  fn: function () {
                    return [_c("router-view", { key: _vm.$route.fullPath })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-bottom",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarBottom" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-right",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarRight" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4192362263
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultPage.isMobile === false && _vm.resultPage.isFullRes === false
        ? _c("MediumLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "topbar",
                  fn: function () {
                    return [_c("router-view", { attrs: { name: "Topbar" } })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left-stacked",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "SidebarLeftStacked" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left-medium",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "SidebarLeftMedium" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas-ad",
                  fn: function () {
                    return [
                      true === false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center banner-ad-size",
                            },
                            [_c("div", { attrs: { id: _vm.adId } })]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary-nav",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SecondaryNav" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas",
                  fn: function () {
                    return [_c("router-view", { key: _vm.$route.fullPath })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-right-medium",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "SidebarRightMedium" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1727892635
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultPage.isMobile === true
        ? _c("MobileLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "main-canvas",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "MobileDefault" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              545162829
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }